import * as React from "react";

function Preview() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="white" />
      <circle cx="25" cy="25" r="25" fill="#0074BD" fillOpacity="0.25" />
      <path
        d="M11 18.5C11 16.5859 12.5312 15 14.5 15H35.5C37.4141 15 39 16.5859 39 18.5V32.5C39 34.4688 37.4141 36 35.5 36H14.5C12.5312 36 11 34.4688 11 32.5V18.5ZM13.625 18.5V19.7578L23.0312 27.4688C24.1797 28.3984 25.7656 28.3984 26.9141 27.4688L36.375 19.7578V18.5C36.375 18.0625 35.9375 17.625 35.5 17.625H14.5C14.0078 17.625 13.625 18.0625 13.625 18.5ZM13.625 23.1484V32.5C13.625 32.9922 14.0078 33.375 14.5 33.375H35.5C35.9375 33.375 36.375 32.9922 36.375 32.5V23.1484L28.6094 29.4922C26.4766 31.2422 23.4688 31.2422 21.3359 29.4922L13.625 23.1484Z"
        fill="#0074BD"
      />
    </svg>
  );
}

export default Preview;
